import { render, staticRenderFns } from "./subcategoryArchive.vue?vue&type=template&id=09bb6499&"
import script from "./subcategoryArchive.vue?vue&type=script&lang=js&"
export * from "./subcategoryArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports